<script lang="ts">
const MAX_FILES = 5
</script>
<script setup lang="ts">
import { translate } from "~/utils/helpers"

const { state: gestureState } = useGestures()
const { selectedFiles } = useSelection()
const dragged = ref<HTMLDivElement>()

const initialX = gestureState.value.mousePosition?.clientX || -1000
const initialY = gestureState.value.mousePosition?.clientY || -1000

function manuallyUpdateDragPosition(event: MouseEvent) {
  dragged.value!.style.transform = translate(event.clientX, event.clientY)
}

/** Max number of visible files in the drag view */


const visible = computed(() => Object.values(selectedFiles.value).slice(0, MAX_FILES))

onMounted(() => {
  document.body.addEventListener("mousemove", manuallyUpdateDragPosition, true)
})
onUnmounted(() => {
  document.body.removeEventListener("mousemove", manuallyUpdateDragPosition, true)
})
</script>

<template>
  <div
    ref="dragged"
    class="dragged-file"
    :style="{
      transform: translate(initialX, initialY),
    }"
  >
    <div class="dragged-files">
      <file-item
        v-for="file, idx in visible"
        :key="file.id"
        class="dragged-file-inner"
        :style="{
          opacity: (0.33 ** idx),
        }"
        :file
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dragged-files
  @apply gap-1 flex flex-col

.dragged-file
  @apply pointer-events-none absolute transform z-drag-layer
.dragged-file-inner
  @apply max-w-[200px] gap-[#{$sidebar-gap-item-icon}]
</style>
